import { checkPasswordsMatch } from './lib/validations'
import './lib/jquery'

if (document.querySelector('.registration-form')) {
  document.addEventListener('DOMContentLoaded', () => {
    const passwordInput = $('#user_password')
    const confirmationInput = $('#user_password_confirmation')
    passwordInput.on('change keyup paste', () => checkPasswordsMatch(passwordInput, confirmationInput))
    confirmationInput.on('change keyup paste', () => checkPasswordsMatch(passwordInput, confirmationInput))
  })
}
